import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";
import ImageGallery from 'react-image-gallery';
import "./../image-gallery.css";

export default () => {
    const title = 'Леликово. Тенисный корт';

    const images = [
        {
            original: require('./../img/virtualtours/lelikovokort/k01.jpg'),
            thumbnail: require('./../img/virtualtours/lelikovokort/k01m.jpg'),
        },
        {
            original: require('./../img/virtualtours/lelikovokort/k02.jpg'),
            thumbnail: require('./../img/virtualtours/lelikovokort/k02m.jpg'),
        },
        {
            original: require('./../img/virtualtours/lelikovokort/k03.jpg'),
            thumbnail: require('./../img/virtualtours/lelikovokort/k03m.jpg'),
        },
        {
            original: require('./../img/virtualtours/lelikovokort/k04.jpg'),
            thumbnail: require('./../img/virtualtours/lelikovokort/k04m.jpg'),
        },
        {
            original: require('./../img/virtualtours/lelikovokort/k05.jpg'),
            thumbnail: require('./../img/virtualtours/lelikovokort/k05m.jpg'),
        },
        {
            original: require('./../img/virtualtours/lelikovokort/k06.jpg'),
            thumbnail: require('./../img/virtualtours/lelikovokort/k06m.jpg'),
        },
        {
            original: require('./../img/virtualtours/lelikovokort/k07.jpg'),
            thumbnail: require('./../img/virtualtours/lelikovokort/k07m.jpg'),
        },
        {
            original: require('./../img/virtualtours/lelikovokort/k08.jpg'),
            thumbnail: require('./../img/virtualtours/lelikovokort/k08m.jpg'),
        },
        {
            original: require('./../img/virtualtours/lelikovokort/k09.jpg'),
            thumbnail: require('./../img/virtualtours/lelikovokort/k09m.jpg'),
        },
        {
            original: require('./../img/virtualtours/lelikovokort/k10.jpg'),
            thumbnail: require('./../img/virtualtours/lelikovokort/k10m.jpg'),
        },
        {
            original: require('./../img/virtualtours/lelikovokort/k11.jpg'),
            thumbnail: require('./../img/virtualtours/lelikovokort/k11m.jpg'),
        },
        {
            original: require('./../img/virtualtours/lelikovokort/k12.jpg'),
            thumbnail: require('./../img/virtualtours/lelikovokort/k12m.jpg'),
        },
        {
            original: require('./../img/virtualtours/lelikovokort/k13.jpg'),
            thumbnail: require('./../img/virtualtours/lelikovokort/k13m.jpg'),
        },
        {
            original: require('./../img/virtualtours/lelikovokort/k14.jpg'),
            thumbnail: require('./../img/virtualtours/lelikovokort/k14m.jpg'),
        },
        {
            original: require('./../img/virtualtours/lelikovokort/k15.jpg'),
            thumbnail: require('./../img/virtualtours/lelikovokort/k15m.jpg'),
        },
        {
            original: require('./../img/virtualtours/lelikovokort/k16.jpg'),
            thumbnail: require('./../img/virtualtours/lelikovokort/k16m.jpg'),
        },
    ];

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <div className="onehalf-col-cell">
                        <h2>{title}</h2>
                        <ImageGallery
                            items={images}
                            showIndex={false}
                            showBullets={true}
                            infinite={true}
                            showThumbnails={true}
                            showFullscreenButton={false}
                            showGalleryFullscreenButton={false}
                            showPlayButton={false}
                            showGalleryPlayButton={false}
                            showNav={true}
                            isRTL={false}
                            slideDuration={300}
                            slideInterval={2000}
                            slideOnThumbnailOver={false}
                            thumbnailPosition={'right'}
                            useWindowKeyDown={true}
                        />
                    </div>
                </div>

                <div className="pageitem">
                    <p>Панасюк Иван Павлович в 2007 году на свои средства в родной деревне Леликово построил теннисный корт.</p>
                    <p>Пользоваться можно бесплатно. Даже при отсутствии своего инвентаря игроку выдадут ракетки и мячи. Не взимается плата и за пользование раздевалками и автомобильной парковкой. Одновременно может тренироваться до 20 человек. Корт работает круглые сутки. Для этого установлена подсветка.</p>
                </div>
            </div>
        </>
    );
}